import { Colors, Shadows, Typography } from '@zapier/design-system';
import { css } from '@emotion/react';
import { mediaQueries } from '@zapier/identity-utils';
import { useTranslations } from 'next-intl';
import { OpenAILogo } from './OpenAILogo';

const rootStyles = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const headerStyles = css`
  ${Typography.PageHeader}
  color: ${Colors.GrayWarm10};
  margin-bottom: 30px;
  margin-top: 30px;
  text-align: left;

  ${mediaQueries.tablet} {
    padding-right: 50px;
  }

  ${mediaQueries.desktop} {
    ${Typography.PageHeader}
  }
`;

const descriptionStyle = css`
  ${Typography.Body1}
  color: ${Colors.GrayWarm9};
  margin-bottom: 30px;
  text-align: left;

  ${mediaQueries.tablet} {
    padding-right: 50px;
  }

  ${mediaQueries.desktop} {
    ${Typography.Body1}
  }
`;

const iconStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 40px;
  width: 40px;
  padding: 10px;
  border: 1px solid ${Colors.GrayWarm3};
  box-shadow: ${Shadows.elevation5};

  ${mediaQueries.tablet} {
    height: 60px;
    width: 60px;
  }
`;

export function NLASignUpPromo() {
  const t = useTranslations('nla-signup-promo');

  return (
    <div css={rootStyles}>
      <div css={iconStyle}>
        <OpenAILogo />
      </div>
      <h3 css={headerStyles}>{t('heading')}</h3>
      <p css={descriptionStyle}>{t('description')}</p>
    </div>
  );
}
